import { baseSplitZodSchema } from "@redotech/redo-model/split";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getSplit = {
  name: "getSplit" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({ split: baseSplitZodSchema }),
};
